import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { getFailure } from "../../../user-dashboard/userProjectSlice";
import { getErrorFailure } from "../../../error/errorHandlingSlice";
import { renewAccessTokenIfGoingExpire } from "../../../api/authApi";
import { createElementSuccess, createSiteSuccess, getAllSitesSuccess, getSiteDetailsSuccess, uploadProtocolSuccess } from "./maintainenceInspectionSlice";
import { createAndDownloadBlobFile } from "../../../utils/helper";

export const getAllSites = () => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites`,
        headers: {
          Accept: "application/json",
          Authorization: tokenHeader,
        },
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      console.log("API response", response.data);
      dispatch(getAllSitesSuccess(response.data));
    }
  } catch (error) {
    if (error.response || error.request) {
      let payload = {};
      payload = {
        type: "ERROR",
        messages:
          "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
        error: error?.response?.data,
        responseError: "true",
      };
      dispatch(getErrorFailure(payload));
    }
  }
};

export const createSite = (request) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: tokenHeader,
        },
        data: request.data,
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(createSiteSuccess(response.data));
    }
  } catch (error) {
    let payload = {};
    payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
  }
};

export const getSiteDetails = (siteId) => async (dispatch) => {
  try {
    console.log(siteId, 'site isd from breadcrumbs')
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites/${siteId}/inspections`,
        headers: {
          Accept: "application/json",
          Authorization: tokenHeader,
        },
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      console.log("API response", response.data);
      dispatch(getSiteDetailsSuccess(response.data));
    }
  } catch (error) {
    if (error.response || error.request) {
      let payload = {};
      payload = {
        type: "ERROR",
        messages:
          "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
        error: error?.response?.data,
        responseError: "true",
      };
      dispatch(getErrorFailure(payload));
    }
  }
};

export const createElement = (request) => async (dispatch) => {
  try {
    console.log("Request data in API", request);
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const siteId = request.data.siteId;
    const response = await trackPromise(
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites/${siteId}/inspections`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: tokenHeader,
        },
        data: request.data,
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(createElementSuccess(response.data));
    }
  } catch (error) {
    let payload = {};
    payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
  }
};

export const uploadProtocol = (request) => async (dispatch) => {
  try {
    console.log("Request data in API", request);
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    // Debug log FormData contents
    if (request.data instanceof FormData) {
      for (let pair of request.data.entries()) {
        console.log("FormData:", pair[0], pair[1]);
      }
    }
    const response = await trackPromise(
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/protocols/upload`,
        headers: {
          Accept: "application/json",
          Authorization: tokenHeader,
        },
        data: request.data, // Use request.data, not request.data.FormData
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(uploadProtocolSuccess(response.data));
      // Optionally, you can dispatch another action to update the protocols list
      // after a successful upload.
    }
  } catch (error) {
    let payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
  }
};

export const getProtocols = (inspectionId) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/protocols/inspection/${inspectionId}`,
        headers: {
          Accept: "application/json",
          Authorization: tokenHeader,
        },
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
      return null;
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response || error.request) {
      let payload = {
        type: "ERROR",
        messages:
          "OOPS! Something might have went wrong, Please try again.If the issue still exists,Please contact guru@taeurope.com",
        error: error?.response?.data,
        responseError: "true",
      };
      dispatch(getErrorFailure(payload));
    }
    return null;
  }
}

export const deleteProtocol = (protocolId) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "delete",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/protocols/${protocolId}`,
        headers: {
          Accept: "application/json",
          Authorization: tokenHeader,
        },
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
      return null;
    } else {
      return response.data;
    }
  } catch (error) {
    if (error.response || error.request) {
      let payload = {
        type: "ERROR",
        messages:
          "OOPS! Something might have went wrong, Please try again.If the issue still exists,Please contact guru@taeurope.com",
        error: error?.response?.data,
        responseError: "true",
      };
      dispatch(getErrorFailure(payload));
    }
    return null;
  }
}

// api/maintainenceInspectionApi.js
export const createElementWithAI = ({ siteId, file }) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();

    const form = new FormData();
    form.append("file", file); // must be "file" to match @RequestPart("file")

    const response = await trackPromise(
      axios.post(
        `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites/${siteId}/inspections/ai`,
        form,
        {
          headers: {
            // do NOT set Content-Type manually: axios will set multipart boundary
            Authorization: tokenHeader,
            Accept: "application/json",
          },
        }
      )
    );

    if (response?.data?.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(createElementSuccess(response.data));
    }
  } catch (error) {
    const payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
    return null;
  }
};

export const createExistingElementWithAI = ({ inspectionId, file , siteId}) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();

    const form = new FormData();
    form.append("file", file); // must be "file" to match @RequestPart("file")
    console.log('API called with inspectionId:', inspectionId, 'siteId:', siteId);
    const response = await trackPromise(
      axios.post(
        `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites/${siteId}/inspections/${inspectionId}/ai`,
        form,
        {
          headers: {
            // do NOT set Content-Type manually: axios will set multipart boundary
            Authorization: tokenHeader,
            Accept: "application/json",
          },
        }
      )
    );

    if (response?.data?.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(createElementSuccess(response.data));
    }
  } catch (error) {
    const payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
    return null;
  }
};

export const getInspectionTemplate = () => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/maintenance-and-inspections/sites/fetch-inspection-template`,
        responseType: "arraybuffer",
        headers: {
          Authorization: tokenHeader,
          Accept: "application/xlsx",
        },
      })
    );
    if (!!response) {
      createAndDownloadBlobFile(
        response.data,
        "asset_creation_template",
        "xlsx"
      );
    }
  } catch (error) {
    let payload = {};
    payload = {
      type: "ERROR",
      messages:
        "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
      error: error?.response?.data,
      responseError: "true",
    };
    dispatch(getErrorFailure(payload));
  }
};
